import { useEffect, useState } from "react";
import { Palette, Check, X } from "lucide-react";

export const THEMES = [
  { id: "teal", name: "Humanitarian Teal", desc: "Teal & amber (default)", swatches: ["#0F766E", "#F59E0B", "#FDFBF6"] },
  { id: "ocean", name: "Ocean Blue", desc: "Blue & coral", swatches: ["#1D4ED8", "#F97316", "#F8FAFC"] },
  { id: "forest", name: "Forest Green", desc: "Emerald & marigold", swatches: ["#047857", "#EAB308", "#FDFBF6"] },
  { id: "navy", name: "Deep Navy", desc: "Navy & gold", swatches: ["#1E3159", "#EAB308", "#F8FAFC"] },
  { id: "plum", name: "Royal Plum", desc: "Purple & rose", swatches: ["#7E22CE", "#F43F5E", "#FDF9FF"] },
];

export function applyTheme(id) {
  if (id === "teal") delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = id;
  localStorage.setItem("fscd_theme", id);
}

export function initTheme() {
  const saved = localStorage.getItem("fscd_theme") || "teal";
  if (saved === "teal") delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = saved;
}

export default function ThemeSwitcher() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(localStorage.getItem("fscd_theme") || "teal");

  useEffect(() => { initTheme(); }, []);

  const pick = (id) => { applyTheme(id); setActive(id); };

  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
      {open && (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-2xl p-4 w-64 space-y-2 fade-in" data-testid="theme-panel">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 px-1">Choose a color scheme</p>
          {THEMES.map((t) => (
            <button key={t.id} data-testid={`theme-${t.id}`} onClick={() => pick(t.id)}
              className={`w-full flex items-center gap-3 p-2.5 rounded-xl border text-left transition-colors ${active === t.id ? "border-teal-600 bg-teal-50" : "border-slate-100 hover:border-slate-300"}`}>
              <span className="flex -space-x-1.5 shrink-0">
                {t.swatches.map((c) => <span key={c} className="w-6 h-6 rounded-full border-2 border-white shadow" style={{ background: c }} />)}
              </span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-slate-800">{t.name}</span>
                <span className="block text-[11px] text-slate-400">{t.desc}</span>
              </span>
              {active === t.id && <Check size={16} className="text-teal-700 shrink-0" />}
            </button>
          ))}
          <p className="text-[10px] text-slate-400 px-1">Applies everywhere — landing page and all dashboards.</p>
        </div>
      )}
      <button data-testid="theme-fab" onClick={() => setOpen(!open)} title="Color schemes"
        className="w-14 h-14 rounded-full bg-teal-700 text-white shadow-2xl flex items-center justify-center hover:scale-105 transition-transform">
        {open ? <X size={22} /> : <Palette size={22} />}
      </button>
    </div>
  );
}
